@if (hasProfile){
@if (isProduction || !isVsnBU) {
<div id="page" class="admin-ui-page">
    <adminui-navbar></adminui-navbar>

    @if (showWelcomeDialog){
    <adminui-welcome-dialog></adminui-welcome-dialog>
    }

    <main role="main">
        <router-outlet></router-outlet>

        @if (showNotification){
        <div role="alert" class="ga-notification ga-notification--information toast-alert-gaia toast-main">
            <span class="ga-notification__icon">
                <img src="assets/images/lucide/16_info.svg" width="24" height="24" aria-hidden="true" />
            </span>
            <div class="ga-notification__content">
                <div class="ga-notification__heading">
                    <span class="ga-notification__title">
                        @if(notificationItem?.url){
                        <a href="#" rel="noopener noreferrer" (click)="onClickNotification($event)">{{notificationTitle}}</a>
                        } @else {
                        {{notificationTitle}}
                        }
                    </span>
                    <div class="ga-notification__title-actions">
                        <button type="button" class="close" (click)="closeNotification()" aria-label="Close">
                            <img src="assets/images/lucide/24_close.svg" width="20" height="20" aria-hidden="true" />
                        </button>
                    </div>
                </div>
            </div>
        </div>
        }

        <adminui-loading-widget></adminui-loading-widget>
        <adminui-alert-flash alertFlashName="mainFlashAlert"></adminui-alert-flash>
        <adminui-alert-error alertErrorName="mainErrorAlert"></adminui-alert-error>

    </main>

    <footer>
    </footer>
</div>
} @else {
<adminui-nav-shell>

    @if (showWelcomeDialog){
    <adminui-welcome-dialog></adminui-welcome-dialog>
    }

    <main role="main">
        <router-outlet></router-outlet>

        @if (showNotification){
        <div role="alert" class="ga-notification ga-notification--information toast-alert-gaia toast-main">
            <span class="ga-notification__icon">
                <img src="assets/images/lucide/16_info.svg" width="24" height="24" aria-hidden="true" />
            </span>
            <div class="ga-notification__content">
                <div class="ga-notification__heading">
                    <span class="ga-notification__title">
                        @if(notificationItem?.url){
                        <a href="#" rel="noopener noreferrer" (click)="onClickNotification($event)">{{notificationTitle}}</a>
                        } @else {
                        {{notificationTitle}}
                        }
                    </span>
                    <div class="ga-notification__title-actions">
                        <button type="button" class="close" (click)="closeNotification()" aria-label="Close">
                            <img src="assets/images/lucide/24_close.svg" width="20" height="20" aria-hidden="true" />
                        </button>
                    </div>
                </div>
            </div>
        </div>
        }

        <adminui-loading-widget></adminui-loading-widget>
        <adminui-alert-flash alertFlashName="mainFlashAlert"></adminui-alert-flash>
        <adminui-alert-error alertErrorName="mainErrorAlert"></adminui-alert-error>

    </main>

    <footer>
    </footer>

</adminui-nav-shell>
}
}